import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import LecBankAccountCreatePage from './lec-bank-account-create'
import LecBankAccountListPage from './lec-bank-account-list'
import LecBankAccountUpdatePage from './lec-bank-account-update'

const lecBankAccountRoutes: Route[] = [
  {
    path: Paths.LEC_BANK_ACCOUNTS_LIST_PAGE,
    element: <LecBankAccountListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.LEC_BANK_ACCOUNTS_CREATE_PAGE,
    element: <LecBankAccountCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.LEC_BANK_ACCOUNTS_UPDATE_PAGE,
    element: <LecBankAccountUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default lecBankAccountRoutes
